import React from 'react';
import { createPortal } from 'react-dom';
import { fmt } from './oilApi';
import { sfxClose } from './oilSounds';

const RES = {
  black: {
    name: 'Black Coins', color: 'text-amber-300', glow: 'rgba(245,158,11,0.55)',
    desc: 'Moeda do submundo. Paga trabalhos sujos, escudos e melhorias.',
    hint: 'Cada recarga no site te devolve 0,5% em Black Coins.',
  },
  drops: {
    name: 'Gotas de Petróleo', color: 'text-sky-300', glow: 'rgba(56,189,248,0.55)',
    desc: 'Óleo bruto que sai da sua usina de perfuração.',
    hint: 'Junte gotas e envase barris na Envasadora.',
  },
  fox: {
    name: 'FOX Dólar', color: 'text-emerald-300', glow: 'rgba(16,185,129,0.55)',
    desc: 'Sua fortuna oficial — é ela que define o Ranking dos Magnatas.',
    hint: 'Vem da venda de barris na Bolsa do Petróleo.',
  },
  respect: {
    name: 'Respeito', color: 'text-rose-300', glow: 'rgba(244,63,94,0.55)',
    desc: 'O quanto o submundo te teme.',
    hint: 'Sobe a cada trabalho sujo certeiro e te leva à Lista dos Mais Procurados.',
  },
};

export const OilResourceCard = ({ res, value, onClose }) => {
  const r = RES[res];
  if (!r) return null;
  const close = () => { sfxClose(); onClose(); };
  return createPortal(
    <div className="fixed inset-0 z-[96] flex items-center justify-center bg-black/85 p-6 backdrop-blur-sm"
      data-testid="oil-resource-overlay" onClick={close}>
      <div onClick={(e) => e.stopPropagation()} data-testid={`oil-resource-card-${res}`}
        className="w-full max-w-[300px] rounded-2xl border-2 border-amber-600/70 bg-gradient-to-b from-[#1a1408] to-[#0a0906] p-6 text-center shadow-[0_0_45px_rgba(245,158,11,0.3)]"
        style={{ animation: 'oil-res-pop 340ms cubic-bezier(.16,1,.3,1)' }}>
        <style>{`@keyframes oil-res-pop { from { opacity: 0; transform: scale(.7) } to { opacity: 1; transform: scale(1) } }`}</style>
        <img src={`/oil/ic_${res}.webp`} alt="" className="mx-auto h-20 w-auto"
          style={{ filter: `drop-shadow(0 0 16px ${r.glow})` }} />
        <p className={`mt-3 text-4xl font-black tabular-nums ${r.color}`} data-testid={`oil-resource-value-${res}`}
          style={{ textShadow: `0 0 18px ${r.glow}` }}>{fmt(value || 0)}</p>
        <p className="mt-1 text-[11px] font-black uppercase tracking-[0.22em] text-amber-100/80">{r.name}</p>
        <p className="mt-4 text-xs leading-relaxed text-zinc-300">{r.desc}</p>
        <p className="mt-2 text-[11px] leading-relaxed text-amber-200/70">{r.hint}</p>
        <button onClick={close} data-testid="oil-resource-close"
          className="mt-5 w-full rounded-full border border-amber-600/70 bg-black/60 py-2 text-[10px] font-black uppercase tracking-widest text-amber-300 transition-transform active:scale-95">
          Fechar
        </button>
      </div>
    </div>,
    document.body
  );
};

export default OilResourceCard;
